import React from 'react';
import { Link } from 'react-router-dom';

const BusinessAgencySolutions = () => {
  return (
    <div>
      <section
        id="businesses"
        className="scroll-mt-28 border-y border-[#17211E]/10 bg-white py-24"
      >
        <div className="mx-auto grid max-w-7xl items-end gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div>
            <div className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
              For businesses
            </div>
            <h2 className="text-4xl leading-tight sm:text-5xl">
              One person responsible for the setup, instead of several vendors.
            </h2>
            <p className="mt-6 max-w-xl text-xl leading-relaxed text-[#17211E]/70">
              Website, email, hosting, and support problems overlap. We look at
              the whole environment and tell you what actually needs doing.
              Monthly care uses the same Essential, Managed, and Advanced plans
              — quoted after a Digital Review.
            </p>
          </div>
          <div>
            <ul className="space-y-4 text-lg font-medium text-[#17211E]/80">
              <li>Start with one problem</li>
              <li>Or put the wider setup on a monthly plan</li>
              <li>You talk to the person doing the work</li>
            </ul>
            <Link
              to="/digital-review"
              className="home-button mt-8"
            >
              Tell Us What You Need
            </Link>
          </div>
        </div>
      </section>

      <section id="agencies" className="scroll-mt-28 bg-[#174C3C] py-24 text-white">
        <div className="mx-auto grid max-w-7xl items-end gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div>
            <div className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
              For agencies
            </div>
            <h2 className="text-4xl leading-tight sm:text-5xl">
              White-label delivery behind your brand.
            </h2>
            <p className="mt-6 max-w-xl text-xl leading-relaxed text-white/75">
              Website management, support, and hosting without hiring a full
              technical bench. Your clients stay your clients.
            </p>
          </div>
          <div className="flex flex-col gap-4 sm:flex-row lg:justify-end">
            <Link
              to="/agency-services"
              className="home-button-on-dark"
            >
              Agency Services
            </Link>
            <Link
              to="/agency-plans"
              className="home-button-on-dark-secondary"
            >
              Agency Plans
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessAgencySolutions;
